import {makeStyles} from "@material-ui/core/styles";
import images from "../../../../../../../images";
import {checkPseudoStyles} from "../../formElement/RadioCard/styles";
import {GREY_INFO_COLOR} from "../../../../../../../themes/themeConfigurator";

const replaceRadioWithCheckStyles = {
  // replace radio svg with fontawesome check icon
  '& svg': {
    display: 'none',
  },
  '& .MuiIconButton-root .MuiIconButton-label div::before': checkPseudoStyles
};

const useStyles = makeStyles(theme => ({
  errorContainer: {
    fontFamily: 'Roboto-Bold',
    padding: '0 1rem',
    fontSize: 16,
    margin: '0 1rem',
  },
  item: {
    minHeight: 72,
    padding: theme.spacing(2),
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',

    '&:not(.newDesign)': {
      border: '1px solid #D8DCDF',
      borderRadius: 4,
    },

    '&.newDesign': {
      padding: theme.spacing(3),
      borderRadius: 16,
      boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.10), 0px 1px 3px 1px rgba(0, 0, 0, 0.10)',
      border: '1px solid',
      borderColor: 'transparent',
      '&:hover': {
        boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.15), 0px 2px 6px 2px rgba(0, 0, 0, 0.10)',
        ...replaceRadioWithCheckStyles
      },
    },
    '&.disabled': {
      cursor: 'initial',
      pointerEvents: 'none',
      opacity: 0.5
    },
  },
  title: {
    fontSize: 16,
    marginBottom: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  name: {
    position: 'relative',
  },
  selected: {
    fontFamily: 'Roboto-Bold',
    '&:not(.newDesign)': {
      border: 'none',
      boxShadow: '0px 3px 15px #00000033',
      '& $name::after': {
        position: 'absolute',
        content: '""',
        width: 30,
        height: 30,
        top: '50%',
        left: '100%',
        transform: 'translate(15px, -15px)',
        backgroundImage: `url(${images.select_list_icon})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain'
      }
    },
    '&.newDesign': {
      borderColor: theme.palette.primary.main,
      ...replaceRadioWithCheckStyles
    }
  },
  imageContainer: {
    textAlign: 'center'
  },
  chartImage: {
    objectFit: 'contain',
    maxWidth: '100%',
  },
  infoIcon: {
    color: GREY_INFO_COLOR,
  }
}));

export default useStyles;